import {
  POST_LETTER_CORRECTIONS_CORRECT_REQUEST,
  POST_LETTER_CORRECTIONS_CORRECT_SUCCESS,
  POST_LETTER_CORRECTIONS_CORRECT_FAILURE,
} from '../../constants/ActionTypes'
import * as errMessages from '../../constants/ErrorMessages';

const initialState = {
  isCorrecting: false,
  correctedContents: {},
}

export default (state = initialState, action) => {
  state = {
    ...state,
    errorMessage: '',
  }

  switch (action.type) {
    case POST_LETTER_CORRECTIONS_CORRECT_REQUEST:
      return {
        ...state,
        isCorrecting: true,
      }
    case POST_LETTER_CORRECTIONS_CORRECT_SUCCESS:
      return {
        ...state,
        isCorrecting: false,
        correctedContents: action.payload.data,
      }
    case POST_LETTER_CORRECTIONS_CORRECT_FAILURE:
      return {
        ...state,
        isCorrecting: false,
        errorMessage: action.payload.error.data.message ? action.payload.error.data.message : errMessages.ERR_BAD_FORMAT,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/letterCorrection.js